import { useLayoutEffect } from 'react';
import type {
  TUseEventBusKey,
  TUseEventbusProps
} from 'utils/generic/event-bus';
import { fireEvent, initEventBus } from 'utils/generic/event-bus';

// event type in order to (listen to) or (fire) // Here we can use any type for payload
// eslint-disable-next-line @typescript-eslint/no-explicit-any

export enum CasinoEvent {
  CasinoGamesRendered = 'CasinoGamesRendered'
}

/**
 * Hook allows fire and list events between components
 * @param events - events is object with subscribed callbacks where key is eventName, fire on Subject Observable subscribed event
 * @param deps - dependencies for onEvent
 * @returns Function (fireEvent callback)
 */
// Here we can use any type for dependencies
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useEventbus = <KeyType extends TUseEventBusKey, PayloadType = any>(
  events?: TUseEventbusProps<KeyType, PayloadType>,
  deps: any[] = []
) => {
  useLayoutEffect(() => {
    // skip useEffect if onEvent is empty
    return initEventBus(events);

    // console.log('subscribe', events);
    //
    // if (!events || !Object.values(events).length) {
    //   return;
    // }
    //
    // // subscribe to the Subject Observable
    // const subscription = eventbusSubject.subscribe(({ key, id, payload }) => {
    //   events[key as keyof TUseEventbusProps<KeyType, PayloadType>]?.(
    //     id,
    //     payload
    //   );
    // });
    //
    // // we should unsubscribe after component's unmount to remove extra subscribes
    // return () => {
    //   subscription.unsubscribe();
    // };
  }, deps);

  return {
    // on fireEvent, we should push the event into the eventbus subject's observer
    fireEvent
  };
};

// import { useEffect, useId, useLayoutEffect } from 'react';
//
// import {
//   fireEvent,
//   initEventBus,
//   TUseEventbusProps,
//   EVENT_BUS_LOCAL_STORE
// } from 'utils/generic/event-bus';
//
// export enum CasinoEvent {
//   CasinoGamesRendered = 'CasinoGamesRendered'
// }
//
// /**
//  * Hook allows fire and list events between components
//  * @param events - events is object with subscribed callbacks where key is eventName, fire on Subject Observable subscribed event
//  * @param deps - dependencies for onEvent
//  * @returns Function (fireEvent callback)
//  */
// // Here we can use any type for dependencies
// // eslint-disable-next-line @typescript-eslint/no-explicit-any
// export const useEventbus = <KeyType extends string, PayloadType>(
//   events?: TUseEventbusProps<KeyType, PayloadType>,
//   deps: any[] = []
// ) => {
//   useLayoutEffect(() => {
//     return initEventBus(events);
//   }, [deps]);
//   // const id = useRef(ridGenerator.gCustom());
//
//   // const id = useId();
//   //
//   // const isAlreadyRegistered = id in EVENT_BUS_LOCAL_STORE;
//   // const isDependencyChanged = isAlreadyRegistered
//   //   ? JSON.stringify(deps) !== JSON.stringify(EVENT_BUS_LOCAL_STORE[id].deps)
//   //   : false;
//
//   // if (!isAlreadyRegistered || isDependencyChanged) {
//   //   if (isAlreadyRegistered) {
//   //     EVENT_BUS_LOCAL_STORE[id]?.clean();
//   //     delete EVENT_BUS_LOCAL_STORE[id];
//   //   }
//   //
//   //   const clean = initEventBus(events);
//   //
//   //   if (typeof clean === 'function') {
//   //     console.log('register');
//   //
//   //     EVENT_BUS_LOCAL_STORE[id] = { deps, clean };
//   //   }
//   // }
//   //
//   // useEffect(() => {
//   //   return () => {
//   //     console.log('unrgister');
//   //     EVENT_BUS_LOCAL_STORE[id]?.clean();
//   //     delete EVENT_BUS_LOCAL_STORE[id];
//   //   };
//   // }, []);
//
//   return {
//     // on fireEvent, we should push the event into the eventbus subject's observer
//     fireEvent
//   };
// };
